// Unpublished Work © 2021-2024 Deere & Company.

export const APP_BASE_PATH = '/csc';

export const CustomerRoutes = {
    'ADD_BUSINESS_CONTACT': `${APP_BASE_PATH}/add-business-contact`,
    'ADD_CUSTOMER': `${APP_BASE_PATH}/add-new`,
    'CUSTOMER_SEARCH': `${APP_BASE_PATH}/customer-search`,
    'CUSTOMER_PROFILE': `${APP_BASE_PATH}/profile`,
    'EDIT_CUSTOMER': `${APP_BASE_PATH}/edit-customer`,
    'SELECT_BUSINESS_CONTACT': `${APP_BASE_PATH}/select-business-contact`,
    'DBS_DATA_SHARE': `${APP_BASE_PATH}/dbs-data-share`,
    'CROSS_REFERENCE_DETAILS': `${APP_BASE_PATH}/cross-references`,
    'LOG_HISTORY': `${APP_BASE_PATH}/log-history`,
    'MAINTAIN_CONTACTS': `${APP_BASE_PATH}/maintain-contacts`,
    'ADD_JDF_CUSTOMER': `${APP_BASE_PATH}/add-jdf-customer`,
    'EDIT_JDF_CUSTOMER': `${APP_BASE_PATH}/edit-jdf-customer`,
    'CHECK_HEALTH': `${APP_BASE_PATH}/check-health`
};
